<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div v-if="title" class="card-header">
        <h4 class="card-title">{{title}}</h4>
        <p v-if="description" class="category">{{description}}</p>
      </div>
      <div class="card-content">
        {{message}}
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn btn-wd">{{closeText}}</button>
          <button v-if="actionText" @click="loading = true; action()" class="btn btn-fill btn-wd pull-right">{{actionText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'modal-message',
    data () {
      return {
        loading: false
      }
    },
    props: {
      title: String,
      description: String,
      message: String,
      closeText: {type: String, default: "Close"},
      actionText: {type: String},
      action: {type: Function}
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>